export default __webpack_public_path__ + "static/UK-office-244dcd8ea590bc33df5c26af4a4877a7.jpg";